import isEmpty from 'lodash-es/isEmpty';
import trim from 'lodash-es/trim';
import { type HTMLAttributes, type ReactNode, useMemo } from 'react';
import { Link } from 'react-router';

interface Props extends HTMLAttributes<HTMLAnchorElement> {
  idpId: string | null | undefined;
  children: ReactNode;
  openInNew?: boolean;
}

export const EmployeeIdpLink = ({ idpId, children, openInNew, ...props }: Props) => {
  // Fully anchored (unlike the sibling EmployeeLink's /^\d+/), so a value like "123/../whatever"
  // is rejected rather than truncated and treated as a valid numeric id.
  const canonicalId = useMemo(
    () => (!idpId || isEmpty(trim(idpId)) || !/^\d+$/.test(trim(idpId)) ? null : trim(idpId)),
    [idpId],
  );

  if (!canonicalId) return children;

  return (
    <Link {...props} to={`/performance-review/idp/detail/${canonicalId}`} target={openInNew ? '_blank' : undefined}>
      {children}
    </Link>
  );
};
